import './MediaList.scss';
import { AsyncStateNotification } from '@ui/notifications';
import { createSonarSelector } from '@lib/selectors';
import { InitiativeMediaListItem } from './MediaListItem';
import { LinkModal } from '@ui/LinkModal';
import { useParams } from 'react-router-dom';
import { Collapse, List } from 'antd';
import { COPY_SPECIFIC, NOTIFICATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import { coreActions } from '@sonar-software/sonar-core';
import { FileModal } from '@ui/FileModal';
import React, { useState } from 'react';
import { useAction, useSonarSelector } from '@hooks';
const getFilesDataSelector = createSonarSelector((state) => state.core.initiatives.files.get.data);
const getLinksDataSelector = createSonarSelector((state) => state.core.initiatives.links.get.data);
const postFilesStateSelector = createSonarSelector((state) => state.core.initiatives.files.post);
export const InitiativeMediaList = ({ listSelected, showList }) => {
    const [selectedItem, setSelectedItem] = useState();
    const params = useParams();
    const initiativeId = Number(params.id);
    const files = useSonarSelector(getFilesDataSelector);
    const links = useSonarSelector(getLinksDataSelector);
    const updateFile = useAction(coreActions.requestPatchCoreInitiativesFilesById);
    const updateLink = useAction(coreActions.requestPatchCoreInitiativesLinksById);
    const handleCloseModal = () => {
        setSelectedItem(null);
    };
    const handleUpdateFile = (updatedFile) => {
        if (selectedItem) {
            const { name } = updatedFile;
            const { id } = selectedItem;
            updateFile({
                id,
                initiativeId,
                name
            });
        }
        handleCloseModal();
    };
    const handleUpdateLink = (updatedLink) => {
        if (selectedItem) {
            const { title, url } = updatedLink;
            const { id } = selectedItem;
            updateLink({
                id,
                initiativeId,
                title,
                url
            });
        }
        handleCloseModal();
    };
    const dataSource = listSelected === 'files' ? files === null || files === void 0 ? void 0 : files.results : links === null || links === void 0 ? void 0 : links.results;
    const showFileModal = Boolean(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.contentType);
    const showLinkModal = Boolean(selectedItem && !showFileModal);
    const renderItem = (item) => React.createElement(InitiativeMediaListItem, { listItem: item, setSelectedItem: setSelectedItem });
    return (React.createElement(React.Fragment, null,
        links && files &&
            React.createElement(Collapse, { activeKey: showList ? [1] : [], className: 'media-list', ghost: true, items: [{
                        children: React.createElement(List, { dataSource: dataSource, itemLayout: 'horizontal', locale: { emptyText: COPY_SPECIFIC.CLICK_TO_ADD_LINKS_AND_FILES_TO_INITIATIVE }, renderItem: renderItem, size: 'small' }),
                        key: 1,
                        label: '',
                        showArrow: false
                    }] }),
        React.createElement(FileModal, { file: selectedItem, onCancel: handleCloseModal, onOk: handleUpdateFile, open: showFileModal }),
        React.createElement(LinkModal, { link: selectedItem, onCancel: handleCloseModal, onOk: handleUpdateLink, open: showLinkModal }),
        React.createElement(AsyncStateNotification, { errored: NOTIFICATIONS_COPY.ERROR_GET_INITIATIVES_BY_ID_FILES_DOWNLOAD, failed: NOTIFICATIONS_COPY.FAILED_GET_INITIATIVES_BY_ID_FILES_DOWNLOAD, resetRawAction: coreActions.resetPostCoreInitiativesFiles, stateSelector: postFilesStateSelector })));
};
